import { atom, computed } from "nanostores";

import { getGraph, listGraphs } from "../../api";
import { PaginationParams } from "../../types/pagination.ts";
import { createApiStore } from "../api-store";
import { createPaginationStore } from "../pagination";

interface ModifiableGraphMeta {
  id?: string;
  // For copy operations
  nodeIds?: string[];
  sourceGraphId?: string;
  type: "copy" | "create" | "delete" | "update";
}

export const $graphsMetasPagination = createPaginationStore();

const $paginationParamsString = computed(
  $graphsMetasPagination.$paginationParams,
  (params) => JSON.stringify(params),
);

/**
 * Store containing the list of all available graphs
 */
export const $graphsMetasList = createApiStore(listGraphs, {
  mapToOptions: ([paginationParamsString]) => {
    const paginationParams: PaginationParams = paginationParamsString
      ? JSON.parse(paginationParamsString)
      : { currentPage: 1, pageSize: 10 };

    return {
      query: {
        currentPage: paginationParams.currentPage,
        pageSize: paginationParams.pageSize,
      },
    };
  },
  params: [$paginationParamsString],
  storeKey: "graphsPreviewsList",
});

/**
 * Store for managing graph modification state (create/update/delete operations)
 */
export const $modifiableGraphMeta = atom<ModifiableGraphMeta | null>(null);

/**
 * Store containing the content of the graph being modified
 */
export const $modifiableGraphMetaContent = createApiStore(getGraph, {
  mapToOptions: ([id]) => ({
    path: { id: id || "" },
  }),
  params: [computed($modifiableGraphMeta, (graph) => graph?.id || null)],
  storeKey: "modifiableGraphPreviewContent",
});
